export const FETCH_USER_JOB_ROLES = 'FETCH_USER_JOB_ROLES';
export const FETCH_USER_JOB_ROLES_SUCCESS = 'FETCH_USER_JOB_ROLES_SUCCESS';
export const FETCH_USER_JOB_ROLES_ERROR = 'FETCH_USER_JOB_ROLES_ERROR';

export const FETCH_USER_SKILLS_REQUEST = 'FETCH_USER_SKILLS_REQUEST';
export const FETCH_USER_SKILLS_SUCCESS = 'FETCH_USER_SKILLS_SUCCESS';
export const FETCH_USER_SKILLS_FAIL = 'FETCH_USER_SKILLS_FAIL';

export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAIL = 'FETCH_USERS_FAIL';

export const FETCH_USER_DETAIL_REQUEST = 'FETCH_USER_DETAIL_REQUEST';
export const FETCH_USER_DETAIL_SUCCESS = 'FETCH_USER_DETAIL_SUCCESS';
export const FETCH_USER_DETAIL_FAIL = 'FETCH_USER_DETAIL_FAIL';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';
export const UPDATE_USER_RESET = 'UPDATE_USER_RESET';
export const UPDATE_USER_FROM_WIZARD = 'UPDATE_USER_FROM_WIZARD';

export const UPDATE_USER_EXPERTISE_REQUEST = 'UPDATE_USER_EXPERTISE_REQUEST';
export const UPDATE_USER_EXPERTISE_SUCCESS = 'UPDATE_USER_EXPERTISE_SUCCESS';
export const UPDATE_USER_EXPERTISE_FAIL = 'UPDATE_USER_EXPERTISE_FAIL';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAIL = 'CHANGE_PASSWORD_FAIL';

export const INVITE_STAFF_REQUEST = 'INVITE_STAFF_REQUEST';
export const INVITE_STAFF_SUCCESS = 'INVITE_STAFF_SUCCESS';
export const INVITE_STAFF_FAIL = 'INVITE_STAFF_FAIL';

export const REGISTER_SILA_USER = 'REGISTER_SILA_USER';
export const REGISTER_SILA_USER_SUCCESS = 'REGISTER_SILA_USER_SUCCESS';
export const REGISTER_SILA_USER_FAIL = 'REGISTER_SILA_USER_FAIL';
export const REGISTER_SILA_USER_CANCEL = 'REGISTER_SILA_USER_CANCEL';

export const UPDATE_SILA_USER = 'UPDATE_SILA_USER';
export const UPDATE_SILA_USER_SUCCESS = 'UPDATE_SILA_USER_SUCCESS';
export const UPDATE_SILA_USER_FAIL = 'UPDATE_SILA_USER_FAIL';
export const UPDATE_SILA_USER_CANCEL = 'UPDATE_SILA_USER_CANCEL';

export const GET_SILA_USER = 'GET_SILA_USER';
export const GET_SILA_USER_SUCCESS = 'GET_SILA_USER_SUCCESS';
export const GET_SILA_USER_FAIL = 'GET_SILA_USER_FAIL';

export const GET_USER_WALLET = 'GET_USER_WALLET';
export const GET_USER_WALLET_SUCCESS = 'GET_USER_WALLET_SUCCESS';
export const GET_USER_WALLET_FAIL = 'GET_USER_WALLET_FAIL';

export const FETCH_USER_COMPANIES_REQUEST = 'FETCH_USER_COMPANIES_REQUEST';
export const FETCH_USER_COMPANIES_SUCCESS = 'FETCH_USER_COMPANIES_SUCCESS';
export const FETCH_USER_COMPANIES_FAIL = 'FETCH_USER_COMPANIES_FAIL';

export const FETCH_PRODUCERS_REQUEST = 'FETCH_PRODUCERS_REQUEST';
export const FETCH_PRODUCERS_SUCCESS = 'FETCH_PRODUCERS_SUCCESS';
export const FETCH_PRODUCERS_FAIL = 'FETCH_PRODUCERS_FAIL';

export const SECTION_TO_REDIRECT = 'SECTION_TO_REDIRECT';

export const UPDATE_W9_DOCUMENT_REQUEST = 'UPDATE_W9_DOCUMENT_REQUEST';
export const UPDATE_W9_DOCUMENT_SUCCESS = 'UPDATE_W9_DOCUMENT_SUCCESS';
export const UPDATE_W9_DOCUMENT_FAIL = 'UPDATE_W9_DOCUMENT_FAIL';

export const GET_USER_SILA_KYC = 'GET_USER_SILA_KYC';
export const GET_USER_SILA_KYC_SUCCESS = 'GET_USER_SILA_KYC_SUCCESS';
export const GET_USER_SILA_KYC_FAIL = 'GET_USER_SILA_KYC_FAIL';

export const GET_USER_SILA_KYC_INTERVAL = 'GET_USER_SILA_KYC_INTERVAL';
export const GET_USER_SILA_KYC_INTERVAL_SUCCESS =
  'GET_USER_SILA_KYC_INTERVAL_SUCCESS';
export const GET_USER_SILA_KYC_INTERVAL_FAIL =
  'GET_USER_SILA_KYC_INTERVAL_FAIL';

export const POST_USER_REQUEST_KYC = 'POST_USER_REQUEST_KYC';
export const POST_USER_REQUEST_KYC_SUCCESS = 'POST_USER_REQUEST_KYC_SUCCESS';
export const POST_USER_REQUEST_KYC_FAIL = 'POST_USER_REQUEST_KYC_FAIL';
export const POST_USER_REQUEST_KYC_CANCEL = 'POST_USER_REQUEST_KYC_CANCEL';

export const UPLOAD_KYC_DOCUMENT_REQUEST = 'UPLOAD_KYC_DOCUMENT_REQUEST';
export const UPLOAD_KYC_DOCUMENT_SUCCESS = 'UPLOAD_KYC_DOCUMENT_SUCCESS';
export const UPLOAD_KYC_DOCUMENT_FAIL = 'UPLOAD_KYC_DOCUMENT_FAIL';

//Get plaid link token
export const GET_PLAID_LINK_TOKEN_REQUEST = 'GET_PLAID_LINK_TOKEN_REQUEST';
export const GET_PLAID_LINK_TOKEN_SUCCESS = 'GET_PLAID_LINK_TOKEN_SUCCESS';
export const GET_PLAID_LINK_TOKEN_FAIL = 'GET_PLAID_LINK_TOKEN_FAIL';
export const PLAID_LINK_ACCOUNT_CONNECTED = 'PLAID_LINK_ACCOUNT_CONNECTED';

//Get plaid account
export const GET_PLAID_ACCOUNT_REQUEST = 'GET_PLAID_ACCOUNT_REQUEST';
export const GET_PLAID_ACCOUNT_SUCCESS = 'GET_PLAID_ACCOUNT_SUCCESS';
export const GET_PLAID_ACCOUNT_FAIL = 'GET_PLAID_ACCOUNT_FAIL';

export const GET_PLAID_VERIFY_ACCOUNTS_REQUEST =
  'GET_PLAID_VERIFY_ACCOUNTS_REQUEST';
export const GET_PLAID_VERIFY_ACCOUNTS_SUCCESS =
  'GET_PLAID_VERIFY_ACCOUNTS_SUCCESS';
export const GET_PLAID_VERIFY_ACCOUNTS_FAIL = 'GET_PLAID_VERIFY_ACCOUNTS_FAIL';

export const REMOVE_PLAID_ACCOUNT = 'REMOVE_PLAID_ACCOUNT';
export const REMOVE_PLAID_ACCOUNT_SUCCESS = 'REMOVE_PLAID_ACCOUNT_SUCCESS';
export const REMOVE_PLAID_ACCOUNT_FAIL = 'REMOVE_PLAID_ACCOUNT_FAIL';

export const GET_DOCUMENT_TYPE_USER = 'GET_DOCUMENT_TYPE_USER';
export const GET_DOCUMENT_TYPE_USER_SUCCESS = 'GET_DOCUMENT_TYPE_USER_SUCCESS';
export const GET_DOCUMENT_TYPE_USER_FAIL = 'GET_DOCUMENT_TYPE_USER_FAIL';

export const DISPLAY_REGISTER_USER_WALLET = 'DISPLAY_REGISTER_USER_WALLET';
export const DISPLAY_REGISTER_USER_WALLET_SUCCESS =
  'DISPLAY_REGISTER_USER_WALLET_SUCCESS';

//transfer
export const TRANSFER_MONEY_BY_BANK_ACCOUNT = 'TRANSFER_MONEY_BY_BANK_ACCOUNT';
export const TRANSFER_MONEY_BY_BANK_ACCOUNT_SUCCESS =
  'TRANSFER_MONEY_BY_BANK_ACCOUNT_SUCCESS';
export const TRANSFER_MONEY_BY_BANK_ACCOUNT_FAIL =
  'TRANSFER_MONEY_BY_BANK_ACCOUNT_FAIL';

export const TRANSFER_MONEY_BY_BENJI_ACCOUNT =
  'TRANSFER_MONEY_BY_BENJI_ACCOUNT';
export const TRANSFER_MONEY_BY_BENJI_ACCOUNT_SUCCESS =
  'TRANSFER_MONEY_BY_BENJI_ACCOUNT_SUCCESS';
export const TRANSFER_MONEY_BY_BENJI_ACCOUNT_FAIL =
  'TRANSFER_MONEY_BY_BENJI_ACCOUNT_FAIL';

//transfer from sila to bank
export const TRANSFER_MONEY_FROM_BENJI_TO_BANK_ACCOUNT =
  'TRANSFER_MONEY_FROM_BENJI_TO_BANK_ACCOUNT';
export const TRANSFER_MONEY_FROM_BENJI_TO_BANK_ACCOUNT_SUCCESS =
  'TRANSFER_MONEY_FROM_BENJI_TO_BANK_ACCOUNT_SUCCESS';
export const TRANSFER_MONEY_FROM_BENJI_TO_BANK_ACCOUNT_FAIL =
  'TRANSFER_MONEY_FROM_BENJI_TO_BANK_ACCOUNT_FAIL';

export const REQUEST_PAYMENT_SILA_FROM_PERSONAL_ACCOUNT =
  'REQUEST_PAYMENT_SILA_FROM_PERSONAL_ACCOUNT';
export const REQUEST_PAYMENT_SILA_FROM_COMPANY_ACCOUNT =
  'REQUEST_PAYMENT_SILA_FROM_COMPANY_ACCOUNT';
export const REQUEST_PAYMENT_SILA_SUCCESS = 'REQUEST_PAYMENT_SILA_SUCCESS';
export const REQUEST_PAYMENT_SILA_FAIL = 'REQUEST_PAYMENT_SILA_FAIL';

export const ADD_NEW_ROLE_MEMBER = 'ADD_NEW_ROLE_MEMBER';
export const ADD_NEW_ROLE_MEMBER_SUCCESS = 'ADD_NEW_ROLE_MEMBER_SUCCESS';
export const ADD_NEW_ROLE_MEMBER_FAIL = 'ADD_NEW_ROLE_MEMBER_FAIL';

export const UPDATE_ROLE_MEMBER = 'UPDATE_ROLE_MEMBER';
export const UPDATE_ROLE_MEMBER_SUCCESS = 'UPDATE_ROLE_MEMBER_SUCCESS';
export const UPDATE_ROLE_MEMBER_FAIL = 'UPDATE_ROLE_MEMBER_FAIL';

export const DELETE_ROLE_MEMBER = 'DELETE_ROLE_MEMBER';
export const DELETE_ROLE_MEMBER_SUCCESS = 'DELETE_ROLE_MEMBER_SUCCESS';
export const DELETE_ROLE_MEMBER_FAIL = 'DELETE_ROLE_MEMBER_FAIL';

export const REQUEST_LIST_MEMBERS = 'REQUEST_LIST_MEMBERS';
export const REQUEST_LIST_MEMBERS_SUCCESS = 'REQUEST_LIST_MEMBERS_SUCCESS';
export const REQUEST_LIST_MEMBERS_FAIL = 'REQUEST_LIST_MEMBERS_FAIL';

export const FETCHING_USER_WALLET_BAL_REQUEST =
  'FETCHING_USER_WALLET_BAL_REQUEST';
export const FETCHING_USER_WALLET_BAL_SUCCESS =
  'FETCHING_USER_WALLET_BAL_SUCCESS';
export const FETCHING_USER_WALLET_BAL_FAIL = 'FETCHING_USER_WALLET_BAL_FAIL';
export const FETCHING_USER_WALLET_BAL_RESET = 'FETCHING_USER_WALLET_BAL_RESET';

export const DELETE_USER_ACCOUNT_REQUEST = 'DELETE_USER_ACCOUNT_REQUEST';
export const DELETE_USER_ACCOUNT_SUCCESS = 'DELETE_USER_ACCOUNT_SUCCESS';
export const DELETE_USER_ACCOUNT_FAIL = 'DELETE_USER_ACCOUNT_FAIL';
export const DELETE_USER_ACCOUNT_RESET = 'DELETE_USER_ACCOUNT_RESET';

export const CANCEL_REGISTER_SILA_USER_SAGA = 'CANCEL_REGISTER_SILA_USER_SAGA';
export const CANCEL_UPDATE_SILA_USER_SAGA = 'CANCEL_UPDATE_SILA_USER_SAGA';
export const CANCEL_USER_REQUEST_KYC_SAGA = 'CANCEL_USER_REQUEST_KYC_SAGA';

export const SET_PERSONAL_PLAID_CONNECTION_FAILED =
  'SET_PERSONAL_PLAID_CONNECTION_FAILED';

export const CLEAR_SILA_KYC = 'CLEAR_SILA_KYC';
